import React from 'react';
import { AccessControl } from '../../AccessControl/AccessControl';
import { Button, Flexbox, Tooltip, Typography } from '@hiiretail/synergy-ui';
import { AccessDeniedButton } from '../../../styles/AccessDenied.styles';
import { IconComponent } from '@hiiretail/synergy-ui/dist/types/components/content/Icon/Icon.types';

export type ActionButtonProps = {
  title: string;
  onClick: () => void;
  permission: string;
  disabled: boolean;
  icon?: IconComponent;
  dataTestId: string;
};

export type ActionButtonComponent = React.FC<ActionButtonProps>;

export const ActionButton: ActionButtonComponent = ({
  title,
  onClick,
  permission,
  disabled,
  icon,
  dataTestId,
}) => {
  return (
    <AccessControl
      permission={permission}
      renderIfNoAccess={
        <Tooltip
          title={
            <Flexbox container direction="column">
              <Typography variant="caption" color={() => 'white'}>
                You do not have permissions to perform this action.
              </Typography>
              <Typography variant="caption" color={() => 'white'}>
                Required permissions: {/*@ts-ignore*/}
                <Typography variant="caption" weight="bold" color={() => 'white'}>
                  {permission}
                </Typography>
              </Typography>
            </Flexbox>
          }
        >
          <AccessDeniedButton disabled variant="secondary" data-testid={dataTestId}>
            <Flexbox container alignItems="center" gutter={2}>
              {!!icon && (
                <Flexbox item container alignItems="center">
                  {icon}
                </Flexbox>
              )}
              <Flexbox item container alignItems="center">
                <Typography variant="body2">{title}</Typography>
              </Flexbox>
            </Flexbox>
          </AccessDeniedButton>
        </Tooltip>
      }
    >
      <Button disabled={disabled} variant="secondary" data-testid={dataTestId} onClick={onClick}>
        <Flexbox container alignItems="center" gutter={2}>
          {!!icon && (
            <Flexbox item container alignItems="center">
              {icon}
            </Flexbox>
          )}
          <Flexbox item container alignItems="center">
            <Typography variant="body2">{title}</Typography>
          </Flexbox>
        </Flexbox>
      </Button>
    </AccessControl>
  );
};
